import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { AssistantHeader, EmptyState } from "@/components/assistant/AssistantHeader";
import { MessageList } from "@/components/assistant/MessageList";
import { Composer } from "@/components/assistant/Composer";
import { SuggestionSidebar } from "@/components/assistant/SuggestionSidebar";
import {
  useAssistantChat,
  useAutoScroll,
} from "@/components/assistant/useAssistantChat";

export default function Assistant() {
  const [params] = useSearchParams();
  const focusAd = params.get("ad");
  const [input, setInput] = useState("");
  const { messages, busy, send } = useAssistantChat({ contextAdId: focusAd });
  const scrollRef = useAutoScroll([messages]);

  const submit = (text) => {
    const payload = text ?? input;
    setInput("");
    send(payload);
  };

  return (
    <div className="p-4 sm:p-6 flex flex-col h-full" data-testid="assistant-page">
      <AssistantHeader focusAd={focusAd} />

      <div className="flex-1 grid lg:grid-cols-[1fr_260px] gap-4 min-h-0">
        <div className="border border-slate-200 bg-white rounded-md flex flex-col min-h-[480px]">
          {messages.length === 0 ? (
            <div className="flex-1 p-5">
              <EmptyState />
            </div>
          ) : (
            <MessageList ref={scrollRef} messages={messages} busy={busy} />
          )}
          <Composer
            value={input}
            onChange={setInput}
            onSubmit={() => submit()}
            disabled={busy}
          />
        </div>
        <SuggestionSidebar onPick={(s) => submit(s)} disabled={busy} />
      </div>
    </div>
  );
}
